var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplyBg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1750,
    height: 294,
    viewBox: "0 0 1750 294",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M184.585 287.84H0.264688V6.67998H182.065C218.425 6.67998 250.465 27.2 250.465 75.08C250.465 109.64 235.345 130.52 214.465 142.4C237.505 152.48 254.425 179.48 254.425 215.48C254.425 261.2 221.665 287.84 184.585 287.84ZM85.5847 73.64L80.5447 82.28C97.1047 88.76 130.225 93.8 153.625 93.8V84.08C130.225 84.08 99.6247 77.96 85.5847 73.64ZM81.9847 196.04L76.9447 204.68C93.5047 211.16 133.825 216.2 157.225 216.2V206.48C133.825 206.48 96.0247 200.36 81.9847 196.04ZM495.532 287.84H274.132V6.67998H403.732V187.76H495.532V287.84ZM512.14 147.44V6.67998H642.46V182.36H655.06V6.67998H783.94V147.44C783.94 243.56 726.34 293.6 647.86 293.6C569.74 293.6 512.14 243.92 512.14 147.44ZM1032.39 288.2H809.913V6.67998H1032.39V91.28H917.913V103.88H1032.39V191H917.913V203.6H1032.39V288.2ZM1170.79 183.44C1056.67 174.44 1054.87 124.04 1054.87 98.48C1054.87 36.92 1109.23 0.919992 1186.99 0.919992C1237.75 0.919992 1281.31 14.6 1315.51 33.32V121.88C1270.51 95.96 1228.75 93.08 1186.99 93.08V103.16C1270.51 103.16 1319.11 129.08 1319.11 187.04C1319.11 252.2 1271.95 293.96 1190.59 293.96C1148.83 293.96 1103.83 281.36 1058.47 248.6V167.24C1093.03 183.44 1134.07 193.52 1170.79 193.52V183.44ZM1463.88 287.84H1341.48V6.67998H1463.88V48.8L1440.12 116.12L1449.84 118.64L1488.36 6.67998H1614.36L1560.72 147.08L1614.36 287.84H1488.36L1463.88 216.56V287.84ZM1749.64 6.67998V288.2H1629.76V6.67998H1749.64Z",
    fill: "url(#paint0_linear_78_122)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_78_122",
    x1: 875,
    y1: 24.843,
    x2: 875,
    y2: 366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDE5FC",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE5FC",
    stopOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplyBg1);
export default __webpack_public_path__ + "static/media/apply-bg1.69055c880d0bd1bb5f26996c719990ef.svg";
export { ForwardRef as ReactComponent };